import UploadManager from '../library/upload';
export default new UploadManager();